import { render, staticRenderFns } from "./ViewSearchCert.vue?vue&type=template&id=17409e61"
import script from "./ViewSearchCert.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewSearchCert.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports